import React from "react";
import { useNavigate } from "react-router-dom";
import { useOffline } from "./OfflineProvider";
import { useOfflineKeyState } from "./useOfflineKeyState";

// Header pill: "Offline" while disconnected, "Sync n %" while a snapshot sync
// runs, hidden otherwise. Click → settings › Offline-Nutzung.
export default function OfflineStatusBadge() {
  const { isOnline, syncState, fileSync, tenant } = useOffline();
  const keyState = useOfflineKeyState(tenant);
  const navigate = useNavigate();
  let cls = null;
  let label = null;
  if (!isOnline) {
    cls = "is-offline";
    label = "Offline";
  } else if (syncState?.inFlight && syncState.phase !== "manifest") {
    cls = "is-syncing";
    const pct = syncState.total > 0 ? Math.round((syncState.done / syncState.total) * 100) : null;
    label = pct == null ? "Sync…" : `Sync ${pct} %`;
  } else if (fileSync?.inFlight && fileSync.progress?.total > 0) {
    cls = "is-syncing";
    label = `Dateien ${Math.round((fileSync.progress.done / fileSync.progress.total) * 100)} %`;
  } else if (keyState.encrypted && keyState.hasKey && keyState.wrap !== "ok" && syncState?.lastSync) {
    // Encrypted copy not yet usable offline on this device: one hint, no dialog.
    cls = "is-setup";
    label = keyState.wrap === "stale" ? "Offline: Passwort bestätigen" : "Offline einrichten";
  }
  if (!label) return null;
  return (
    <button
      type="button"
      className={`offline-badge ${cls}`}
      onClick={() => navigate("/route/settings?section=offline")}
      title={cls === "is-setup" ? "Für den Offline-Zugriff einmal das Anmeldepasswort bestätigen" : isOnline ? "Offline-Daten werden synchronisiert" : "Offline – gespeicherte Daten werden verwendet"}
    >
      <span className="offline-badge-dot" aria-hidden="true" />
      {label}
    </button>
  );
}
